export default "__VITE_ASSET__cbe29a39__"